(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["pablo-look-navigation"]) return;
  try {
    
function initPabloLookNavigation(scope=document){
  for(const nav of scope.querySelectorAll('[data-pablo-look-navigation]')){
    if(nav.dataset.ready)continue;
    const gallery=nav.closest('.shopify-section')?.nextElementSibling;
    if(!gallery?.querySelector('.st_Insta-Gallery-Box'))continue;
    let seasons;try{seasons=JSON.parse(nav.dataset.seasons);}catch(_){continue;}
    nav.dataset.ready='true';
    nav.addEventListener('click',event=>{
      const button=event.target.closest('button[data-season]');if(!button)return;
      for(const choice of nav.querySelectorAll('button[data-season]'))choice.setAttribute('aria-pressed',String(choice===button));
      for(const card of gallery.querySelectorAll('.st_Insta-Gallery-Box'))card.hidden=button.dataset.season!=='all'&&seasons[card.dataset.blockId]!==button.dataset.season;
    });
  }
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>initPabloLookNavigation());else initPabloLookNavigation();
document.addEventListener('shopify:section:load',()=>initPabloLookNavigation());

  } catch(e) { console.error(e); }
})();
})();
